<template>
  <div class="pa-3">
    <v-row>
      <v-col cols="12">
        <!-- Reload button -->
        <v-btn color="secondary" @click.stop="reload()">
          <v-icon left>
            mdi-cached
          </v-icon>
        </v-btn>

        <!-- copy rate card form link button -->
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" dense v-bind="attrs" v-on="on">
              <v-icon left>
                mdi-content-copy
              </v-icon> Copy Link
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="co in CO"
              :key="co.id"
              @click="copyLink(co.id)"
            >
              <v-list-item-title>{{ co.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <input type="hidden" id="copy-link" :value="rateCardLink">
        <v-btn color="success" elevation="0" text v-if="rateCardCopied">
          <v-icon left>
            mdi-check
          </v-icon>Copied
        </v-btn>
        <!-- <v-btn color="secondary" @click="$refs.rateCardFileInput.click()" v-if="isAdmin">
          <v-icon left>mdi-home-import-outline</v-icon>Import
        </v-btn>
        <v-btn color="secondary" @click="downloadSampleUpload">
            <v-icon left>mdi-download</v-icon>Import Template
          </v-btn> -->
        <v-btn color="secondary"
          @click="download()">
          <v-icon small>download</v-icon> Export Excel
        </v-btn>
      </v-col>
    </v-row>
    <!-- Rate Card Data Table -->
    <rate-card-data-table :reload="isRefresh" :isDownload="isDownload" />
    <!-- excel import file -->
    <input
      type="file"
      accept=".xlsx"
      id="rateCardFileInput"
      ref="rateCardFileInput"
      style="display: none"
      @change="importFileUpload"
    />
    <!-- import loading -->
    <loading
      :active.sync="importLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import influencerAPIs from '../influencerAPIs';
import userAPIs from '../../User/userAPIs';
import RateCardDataTable from './DataTable';
import config from '@/config';
// import moment from 'moment';
import utils from '@/utils';

export default {
  name: 'Brand Fact Sheet',
  components: {
    RateCardDataTable,
    Loading
  },
  data() {
    return {
      rateCardLink: '',
      rateCardCopied: false,
      importLoading: false,
      importItems: [],
      viewID: null,
      isRefresh: 0,
      isDownload: 0,
      CO: []
    }
  },
  computed: {
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    isAdmin: function() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    }
  },
  methods: {
    copyLink(id) {
      const protocol = window.location.protocol
      const host = window.location.host
      // Find CO by id to get name
      let selectedCO = this.CO.find(co => co.id === id)
      let coName = selectedCO ? selectedCO.name : ''
      this.rateCardLink = `${protocol}//${host}${config.JOIN_COMMUNITY_FORM_URL}?sourceid=${id}&cc=${encodeURIComponent(coName)}`
      let vm = this;
      setTimeout(function() { vm.rateCardCopied = utils.func.copyToClipboard('#copy-link') }, 100)
      setTimeout(function() { vm.rateCardCopied = false }, 1000)
    },
    reload() {
      this.isRefresh += 1
    },
    download() {
      this.isDownload += 1
    },
    async importFileUpload(e) {
      this.importLoading = true
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      if (!uploadedFiles || uploadedFiles.length === 0) {
        this.$swal({
          type: 'info',
          text: 'No file uploaded'
        });
        return;
      }
      let uploadResp = await new Promise((resolve, reject) => {
        var fr = new FileReader();
        fr.onload = (e) => {
          const tmp = utils.func.parserToJson(e.target.result);
          resolve(tmp)
        };
        fr.readAsArrayBuffer(e.target.files[0]);
        fr.onerror = reject;
      });
      // let handleItems = []
      if (!uploadResp.length) return
      let importItems = []
      if (uploadResp.length > 1) {
        importItems = uploadResp[1]
      } else {
        importItems = uploadResp[0]
      }
      this.uploadRateCard(importItems)
    },
    uploadRateCard(importItems) { // importItems : array
      if (importItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          text: 'No Imported Rate Card Found'
        });
        return;
      }
      // let formData = new FormData()
      // formData.append('handles', JSON.stringify(importItems))
      let data = Object.assign({}, {
        importItems
      })
      influencerAPIs
      .importRateCard(data)
      .then(resp => {
        this.importLoading = false
        // if (resp.failedInfluencers !== undefined && resp.failedInfluencers.length > 0) {
        //   this.showFailedImportAlert(resp.failedInfluencers)
        //   return false
        // }
        let success = resp.success
        let fails = resp.failed
        let htmlTxt = `Successfully Imported.`
        if (success) {
          htmlTxt += `<br>Success: ${success}`
        }
        if (Array.isArray(fails) && fails.length > 0) {
          htmlTxt += `<br>Failed Rows at: ${fails.join(', ')}`
        }
        this.$swal({
          title: 'Success',
          icon: 'info',
          html: htmlTxt
        });
        this.reload()
      })
      .catch(err => {
        this.importLoading = false
        console.error(err);
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: `Failed to Import Influencers`
        });
      });
      this.$refs.rateCardFileInput.value = null;
    },
    downloadSampleUpload() {
      var link = document.createElement('a');
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', 'sample_bulkupload');
      link.href = '/static/sample/sample_ratecard_template.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  },
  async mounted() {
    // Get all CO by role
    let response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
    if (response) {
      this.CO = response.users
      this.CO = this.CO.map(co => {
        co.name = `${co.firstName}`
        return co
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?3cdd9b0e